import { createSlice } from '@reduxjs/toolkit';
import { 
  getIngredients, 
  deleteIngredients, 
  editIngredients, postRecipe, 
  editRecipe, 
  getRecipe, 
  deleteRecipe, 
  postIngredients, 
  getRecipeId,
  getLibrary,
  postLibrary,
  deleteLibrary,
  updateLibrary, 
  fetchFilter,
  getRecipeData,
  getPlan,
  postPlanManual,
  updatePlanFood,
  postPlan,
  deleteDishPlan,
  deletePlan,
  deleteFoodList, 
  getFoodList,
  postFoodList,
  updateFoodList,
  getUsersPlans,
  generPlan,
  updatePlan,
  copyPlan,
  addMenuDish,
  editTitle,
  getUsersPage,
  editVisor,
  getUserID,
  deleteUsers,
  getUserActivity,
  getIngPage,
  getUser,
  updateUser,
  getUpdateFieldIngredients,
  editUserAcces,
  acceptRecipeUser, 
  changeSubscription,
  changeSubsVisor,
  userActivities,
  extensionSubs,
  getSort,
  getUserTransaction,
  deleteUserBonus,
  getNote,
  verifyPayment,
  getUserSubs,
  getPayment,
  changeSubStatus,
  editUserBonus,
} from './api.js'

export const reguestSlice = createSlice({
    name: 'ingredients',
    initialState: {
      ingredients: [],
      ingredientsField: [],
      statIng: null,
      statusField: null,
      error: null,
      statusPost: null,
      errorPost: null,
      ingredientsPage: [],
      statusPage: null,
      errorPage: null,
      count: 0,
    },
    reducers: {},
    extraReducers: {
      [getUpdateFieldIngredients.pending]: (state) => {
        state.statusField = 'loading';
        state.error = null;
      },
      [getUpdateFieldIngredients.fulfilled]: (state, action)=> {
        state.statusField = 'resolved'
        state.ingredientsField = action.payload;
      },
      [getIngredients.pending]: (state) => {
        state.statIng = 'loading';
        state.error = null;
      },
      [getIngredients.fulfilled]: (state, action)=> {
        state.statIng = 'resolved'
        state.ingredients = action.payload;
      },
      [getIngPage.pending]: (state) => {
        state.statusPage = 'loading';
        state.errorPage = null;
      },
      [getIngPage.fulfilled]: (state, action)=> { 
        state.statusPage = 'resolved' 
        state.count = Number(action.payload.count)
        state.ingredientsPage = action.payload.data
      },
      [getIngPage.rejected]: (state, action)=> {
        state.statusPage = 'resolved'
        state.ingredientsPage = action.payload; 
        state.statusPage = 'rejected' 
        state.count = 0 
        state.ingredientsPage =[]
        if (action.payload) { 
          state.errorPage = action.payload.message;
        } else {
          state.errorPage = 'Unknown error occurred'; // Общая ошибка, если payload отсутствует
        }
      },
      [postIngredients.pending]: (state) => {
        state.statusPost = 'loading';
        state.errorPost = null;
      },
      [postIngredients.fulfilled]: (state, action)=> {
        state.statusPost = 'resolved'
        state.ingredients.unshift(action.payload)
      },
      [postIngredients.rejected]: (state, action)=> {
        state.statusPost = 'rejected'
        state.errorPost = action.payload
      },
      [deleteIngredients.fulfilled]: (state, action)=> {
        state.sts = 'resolved'
        state.ingredients = state.ingredients.filter(ingredients => ingredients._id !== action.payload._id);
      },
      [editIngredients.fulfilled]: (state, action)=> {
        state.sts = 'resolved'
        state.ingredients = state.ingredients.map(ingredients => ingredients._id === action.payload._id ? action.payload : ingredients);
      }, 
      [getIngredients.rejected]: (state, action)=> {
        state.statIng = 'rejected'
        state.ingredients = action.payload;
      },
    }
  })
  
export const currentUserSlice = createSlice({
  name: 'currentUser',
    initialState: {
    currentUser: {}, 
    activity: [], 
    userData:[],
    rate: {}, 
    loggedIn: null,
    recipeOwner: '',
    statusOwner: null,
    statusUser: null,
    errorUser: null, 
    statuActive: null,
    errorActive: null, 
    statusTextUser: ''
  },
  reducers: { 
    infoDelete(state, action) {
      state.statusTextUser = '' 
    },
  }, 
  extraReducers: (builder) => {
    builder 
     .addCase(getUser.pending, (state) => {
        state.statusUser = 'loading';
        state.errorUser = null;
      })
      .addCase(getUser.fulfilled, (state, action)=> {
        state.statusUser = 'resolved'
        state.currentUser = action.payload;
        state.rate = action.payload.subscription
        state.loggedIn = true
        state.errorUser = null;
      })
      .addCase(getUser.rejected, (state, action)=> {
        state.statusUser = 'rejected'
        state.currentUser = {};
        state.loggedIn = false 
        state.errorUser = action.error.message;
      })
      .addCase(updateUser.pending, (state) => {
        state.statusUser = 'loading';
        state.errorUser = null;
      })
      .addCase(updateUser.fulfilled, (state, action)=> {
        state.statusUser = 'resolved'
        state.currentUser = action.payload; 
        state.statusTextUser = 'Данные успешно обновлены' 
        state.errorUser = null;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.statusUser = 'rejected'; 
        state.errorUser = action.error.message;
      }) 
      .addCase(extensionSubs.pending, (state, action)=> {
        state.statusUser = 'loading';
        state.errorUser = null;
      
      }) 
      .addCase(extensionSubs.fulfilled, (state, action)=> {
        state.statusUser = 'resolved'
        state.currentUser = action.payload.user; 
        state.rate = action.payload.subscription
        state.statusTextUser = action.payload.message
        state.errorUser = null;
      }) 
      .addCase(extensionSubs.rejected, (state, action)=> {
        state.statusUser = 'rejected'; 
        state.errorUser = action.error.message;
      }) 
      .addCase(changeSubscription.pending, (state, action)=> { 
        state.statusUser = 'loading';
        state.errorUser = null;
      })
      .addCase(changeSubscription.fulfilled, (state, action)=> { 
        state.statusUser = 'resolved'
        state.currentUser = action.payload.user; 
        state.rate = action.payload.subscription
        state.statusTextUser = action.payload.message
        state.errorUser = null;
      })
      .addCase(changeSubscription.rejected, (state, action)=> {  
        state.statusUser = 'rejected'; 
        state.errorUser = action.error.message;
      })
      .addCase(userActivities.pending, (state) => {
        state.statusActive = 'loading';
        state.errorActive = null;
      })
      .addCase(userActivities.fulfilled, (state, action)=> {
        state.statusActive = 'resolved'
        state.activity = action.payload.activities; 
        state.userData = action.payload.userInfo; 
      })
      .addCase(userActivities.rejected, (state, action)=> {
        state.statusActive = 'rejected'
        state.activity = []; 
        state.errorActive = action.error.message;
      })
      /*.addCase(getRecipeOwnerData.pending, (state) => {
        state.statusOwner = 'loading';
        state.error = null;
      })
      .addCase(getRecipeOwnerData.fulfilled, (state, action)=> {
        state.statusOwner = 'resolved'; 
        state.recipeOwner = action.payload;
      })
      .addCase(getRecipeOwnerData.rejected, (state, action)=> { 
        state.statusOwner = false;
        state.recipeOwner = false; 
      })*/
    }
  })
export const reguestRecipeIdSlice = createSlice({
    name: 'recipe',
    initialState: {
      recipe: {},
      statusRecipe: null,
      statusLike: null,
      errorRecipe: null,
    },
    reducers: {},
    extraReducers: {
      [getRecipeId.pending]: (state) => {
        state.statusRecipe = 'loading';
        state.errorRecipe = null; 
      },
      [getRecipeId.rejected]: (state, action)=> {
        state.statusRecipe = 'rejected'
        state.recipe = action.payload;
      },
      [getRecipeId.rejected]: (state, action)=> {
        state.statusRecipe = 'rejected'; 
        state.errorRecipe = action.error.message; 
      },
      [editRecipe.pending]: (state) => {
        state.statusRecipe = 'loading';
        state.errorRecipe = null;
      },
      [editRecipe.rejected]: (state, action)=> {
        state.statusRecipe = 'resolved' 
        state.recipe = action.payload 
      },
      [editRecipe.rejected]: (state, action)=> {
        state.statusRecipe = 'rejected'  
        state.errorRecipe = action.error.message;  
      }, 
    }
  })

  export const reguestGetSlice = createSlice({
    name: 'recipes',
    initialState: {
      recipes: [],
      edge: {},
      recipePage: [],
      recipesLimitData: [], //Состояние ограниченного числа карточек
      statusLim: null,  
      errorLim: null,
      totalCount: 0,
      sts: null,
      error: null,
      fetching: null,
    },
    reducers: {},
    extraReducers: {
      [getRecipe.pending]: (state) => {
        state.sts = 'loading';
        state.error = null;
      },
      [getRecipe.fulfilled]: (state, action)=> {
        state.sts = 'resolved'
        state.recipes = action.payload;
      },
      [getRecipe.rejected]: (state, action)=> {
        state.sts = 'rejected'
        state.recipes = action.payload;
      },
       [getRecipeData.pending]: (state) => {
        state.statusLim = 'loading';
        state.errorLim = null;
      },
      [getRecipeData.fulfilled]: (state, action)=> {
        state.statusLim = 'resolved'
        state.recipesLimitData = action.payload;
      },
      [getRecipeData.rejected]: (state, action)=> {
        state.statusLim = 'rejected'
        state.recipesLimitData = action.payload;
      },
      [acceptRecipeUser.pending]: (state) => {
        state.sts = 'loading';
        state.error = null;
      },
      [acceptRecipeUser.fulfilled]: (state, action)=> {
        const { updatedRecipe } = action.payload;
        state.sts = 'resolved';
        state.recipes = state.recipes.map(recipe => 
          recipe._id === updatedRecipe._id 
            ? { ...recipe, status: updatedRecipe.status } 
            : recipe
        );
      },
      [acceptRecipeUser.rejected]: (state, action)=> {
        state.sts = 'rejected'  
        console.log(action.error.message)
        state.error = action.error.message; 
      },
      [postRecipe.fulfilled]: (state, action)=> {
        state.sts = 'resolved' 
        state.recipes.push(action.payload)
        console.log(action)
      },
      [deleteRecipe.fulfilled]: (state, action)=> {
        state.sts = 'resolved'
        state.recipes = state.recipes.filter(recipe => recipe._id !== action.payload._id);
      },
      [editRecipe.fulfilled]: (state, action)=> {
        state.sts = 'resolved'
        state.recipes = state.recipes.map(recipe => recipe._id === action.payload._id ? action.payload : recipe);
      },
     
      [fetchFilter.pending]: (state) => {
        state.fetching = 'loading';
        state.errorPage = null;
      },
      [fetchFilter.fulfilled]: (state, action)=> {
        state.fetching = 'resolved' 
        state.totalCount = Number(action.payload.count)
        state.recipes = action.payload.data
      },
      [getSort.pending]: (state, action)=> {  
        state.fetching = 'loading' 
      }, 
      [getSort.fulfilled]: (state, action)=> {  
        state.edge = action.payload;
        state.fetching = 'resolved' 
      }, 
      [getSort.rejected]: (state, action)=> {   
        state.fetching = 'rejected' 
      }, 
      
    }
  })

  export const reguestUsersSlice = createSlice({
    name: 'users',
    initialState: {
      users: [],
      totalCount: 0,
      userActiv: [],
      statusUser: null,
      statusUserActiv: null,
      errorUser: null,
    },
    reducers: {},
    extraReducers: {
      [getUsersPage.pending]: (state) => {
        state.statusUser = 'loading';
        state.errorUser = null; 
      },
      [getUsersPage.rejected]: (state, action)=> {
        state.statusUser = 'rejected' 
      },
      [getUsersPage.fulfilled]: (state, action)=> {
        state.statusUser = 'resolved'
        state.users = action.payload.data
        state.totalCount = Number(action.payload.count)
      },
      
      [editUserAcces.pending]:(state) => {
        state.statusUser = 'loading';
        state.errorUser = null;
      },
      [editUserAcces.fulfilled]: (state, action) => {
        state.statusUser = 'resolved'
        state.users = state.users.map(user => user._id === action.payload._id ? action.payload : user);
      },
      [editUserAcces.rejected]: (state, action)=> {
        state.statusUser = 'rejected'  
        state.errorUser = action.error.message;
      },
      [editUserBonus.pending]:(state) => {
        state.statusUser = 'loading';
        state.errorUser = null;
      },
      [editUserBonus.fulfilled]: (state, action) => {
        state.statusUser = 'resolved'
        state.users = state.users.map(user => user._id === action.payload.user._id ? action.payload.user : user);
      },
      [editUserBonus.rejected]: (state, action)=> {
        state.statusUser = 'rejected'  
        state.errorUser = action.error.message;
      },
      [changeSubsVisor.pending]: (state, action) => { 
        state.statusUser = 'loading';
        state.errorUser = null;
      },
      [changeSubsVisor.fulfilled]: (state, action) => {  
        state.statusUser = 'resolved'
        state.users = state.users.map(user => 
          user._id === action.payload.subscription.userId 
            ? { 
                ...user, 
                subscription: action.payload.subscription 
              } 
            : user
        );
      },
      [changeSubsVisor.rejected]: (state, action) => {   
        state.statusUser = 'rejected'; 
        state.errorUser = action.error.message;
      }, 
      [deleteUsers.pending]: (state) => {
        state.statusUser = 'loading';
        state.errorUser = null; 
      },
      [deleteUsers.rejected]: (state, action)=> {
        state.statusUser = 'rejected' 
      },
      [deleteUsers.fulfilled]: (state, action)=> {
        state.statusUser = 'resolved' 
        state.users = state.users.filter(users => users._id !== action.payload._id);
      },
      [getUserActivity.pending]: (state) => {
        state.statusUserActiv = 'loading';
        state.errorUser = null; 
      },
      [getUserActivity.rejected]: (state, action)=> {
        state.statusUserActiv = 'rejected' 
      },
      [getUserActivity.fulfilled]: (state, action)=> {
        state.statusUserActiv = 'resolved' 
        state.userActiv = action.payload 
      },
      [getUserID.pending]: (state) => {
        state.statusUser = 'loading';
        state.errorUser = null; 
      },
      [getUserID.rejected]: (state, action)=> {
        state.statusUser = 'rejected' 
      },
      [getUserID.fulfilled]: (state, action)=> {
        state.statusUser = 'resolved' 
        state.users = action.payload
      },
      [editVisor.pending]: (state) => {
        state.statusUser = 'loading';
        state.errorUser = null; 
      }, 
      [editVisor.fulfilled]: (state, action)=> {
        state.statusUser = 'resolved'
        state.users = state.users.map(user => user._id === action.payload._id ? action.payload : user);
      },

    }
  })

  export const reguestLibrarySlice = createSlice({
    name: 'lib',
    initialState: {
      lib: [],
      statusLib: null,
      error: null,
      statusPost: null,
      errorPost: null,
    },
    reducers: {},
    extraReducers: {
      [getLibrary.pending]: (state) => {
        state.statusLib = 'loading';
        state.error = null;
      },
      [getLibrary.fulfilled]: (state, action)=> {
        state.statusLib = 'resolved' 
        state.lib = action.payload;
      },
      [postLibrary.pending]: (state) => {
        state.statusPost = 'loading';
        state.errorPost = null;
      },
      [postLibrary.fulfilled]: (state, action)=> {
        state.statusPost = 'resolved'
        console.log(action.payload)
        state.lib = action.payload
      },
      [deleteLibrary.fulfilled]: (state, action)=> {
        state.sts = 'resolved'
        state.lib = action.payload
      },
      [postLibrary.rejected]: (state, action)=> {
        state.statusPost = 'rejected'
        state.errorPost = action.payload
      },
      [updateLibrary.fulfilled]: (state, action)=> {
        state.sts = 'resolved'
        state.lib = action.payload
      },
    }
  })

    export const reguestNoteSlice = createSlice({
    name: 'note',
    initialState: {
      note: [],
      statusNote: null,
      errorNote: null, 
    },
    reducers: {},
    extraReducers: {
      [getNote.pending]: (state) => {
        state.statusNote = 'loading';
        state.errorNote = null;
      },
      [getNote.fulfilled]: (state, action)=> {
        state.statusNote = 'resolved' 
        state.note = action.payload;
      },
      
    }
  })
 
  export const reguestPaymentSlice = createSlice({
    name: 'payment',
    initialState: {
      payments: [],
      bonus: [],
      subsHistory: [],
      statusBonus: null,
      errorBonus: null,
      transaction: [],
      statusTrans: null,
      errorTrans: null,
      statusPay: null, 
      subsPay: null,
      errorPay: null,
    },
    reducers: {
      resetPaymentStatus: (state) => {
        state.statusPay = 'idle';
        state.subsPay = null;
        state.errorPay = null;
      }
    },
    extraReducers: {
      [getUserTransaction.pending]: (state) => { 
        state.statusTrans = 'loading';
        state.errorTrans = null;
        
      },
      [getUserTransaction.fulfilled]: (state, action) => {  
        state.statusTrans = 'resolved'
        state.transaction = action.payload;
        state.errorTrans = null;
      },
      [getUserTransaction.rejected]: (state, action) => {  
        state.statusTrans = 'rejected' 
        state.errorTrans = action.error.message;
      },
      [getUserSubs.pending]: (state) => { 
        state.statusTrans = 'loading';
        state.errorTrans = null;
        
      },
      [getUserSubs.fulfilled]: (state, action) => {  
        state.statusTrans = 'resolved'
        state.subsHistory = action.payload;
        state.errorTrans = null;
      },
      [getUserSubs.rejected]: (state, action) => {  
        state.statusTrans = 'rejected' 
        state.errorTrans = action.error.message;
      },
      [changeSubStatus.pending]: (state) => { 
        state.statusTrans = 'loading';
        state.errorTrans = null;
        
      },
      [changeSubStatus.fulfilled]: (state, action) => {  
        state.statusTrans = 'resolved'
        state.subsHistory = state.subsHistory.map(subs => subs._id === action.payload.subscription._id ? action.payload.subscription : subs); 
        state.errorTrans = null;
      },
      [changeSubStatus.rejected]: (state, action) => {  
        state.statusTrans = 'rejected' 
        state.errorTrans = action.error.message;
      },
      [verifyPayment.pending]: (state) => { 
        state.statusPay = 'loading';
        state.subsPay = null;
        state.errorPay = null;
      },
      [verifyPayment.fulfilled]: (state, action) => {  
        state.statusPay = 'succeeded';
        state.subsPay = action.payload.subscription; 
      },
      [verifyPayment.rejected]: (state, action) => {  
        state.statusPay = 'rejected' ;
        state.errorPay = action.payload?.message || action.error.message;
      },
      [getPayment.pending]: (state) => { 
        state.statusPay = 'loading';
        state.subsPay = null;
        state.errorPay = null;
      },
      [getPayment.fulfilled]: (state, action) => {  
        state.statusPay = 'resolved'
        state.payments = action.payload.items; 
      },
      [getPayment.rejected]: (state, action) => {  
        state.statusPay = 'rejected' ;
        state.errorPay = action.payload?.message || action.error.message;
      },
      
    }
  })
 

   //Работа с планом питания
 export const reguestPlanSlice = createSlice({
  name: 'plans',
  initialState: {
    plans: [], 
    userPlans: [],
    statusPlan: null,
    error: null,
     statusUserPlan: null,
    errorUserPlan: null,
    creature: false,
    loadingRecipes: [],
    isLoading: false,
    meals: {
      breakfast: false,
      lunch: false,
      dinner: false,
      snack: false,
      supper: false,
      lateDinner: false
    },
  },
  reducers: {
    resetStatus: (state) => {
      state.statusPlan = 'resolved';
      state.error = null;
    },
    setLoading: (state, action) => {
      console.log(action)
      state.isLoading = action.payload
    },
     startRecipeLoading: (state, action) => {
      state.loadingRecipes.push(action.payload);
    },
     endRecipeLoading: (state, action) => {
      state.loadingRecipes = state.loadingRecipes.filter(id => id !== action.payload);
    },
  },
  extraReducers:(builder) => {
    builder
    .addCase(getPlan.pending, (state, action)=> { 
      state.statusPlan = 'loading';
      state.error = null;
      state.creature = true
    })
    .addCase(getPlan.fulfilled, (state, action)=> {  
      state.statusPlan = 'resolved'
      state.plans = action.payload;
      state.creature = false
    })
    .addCase(getPlan.rejected, (state, action)=> {
      state.statusPlan = 'rejected'   
      state.error = action.payload;
  
    })
    .addCase(getUsersPlans.pending, (state, action)=> { 
      state.statusUserPlan = 'loading';
      state.errorUserPlan = null; 
    })
    .addCase(getUsersPlans.fulfilled, (state, action)=> {  
      state.statusUserPlan = 'resolved'
      state.userPlans = action.payload; 
    })
    .addCase(getUsersPlans.rejected, (state, action)=> {
      state.statusUserPlan = 'rejected'   
      state.errorUserPlan = action.payload;
  
    })
    .addCase(postPlan.pending, (state, action)=> {  
      state.statusPlan = 'loading';
      state.error = null;
      state.creature = true
    })
    .addCase(postPlan.fulfilled, (state, action)=> {  
      state.statusPlan = 'resolved' 
      state.plans.push(...action.payload)
      state.creature = false
    })
    .addCase(postPlan.rejected, (state, action)=> {
      state.statusPlan = 'rejected'  
      state.error = action.error.message;  
    })
    .addCase(addMenuDish.pending, (state, action)=> {  
      state.statusPlan = 'loading';
      state.error = null;
      state.creature = true
    })
    .addCase(addMenuDish.fulfilled, (state, action)=> {  
      state.statusPlan = 'resolved' 
      state.plans = state.plans.map(plan => plan._id === action.payload._id ? action.payload : plan)
      state.creature = false
    })
    .addCase(addMenuDish.rejected, (state, action)=> {
      state.statusPlan = 'rejected'  
      state.error = action.payload
    })
    .addCase(copyPlan.pending, (state, action)=> {  
      state.statusPlan = 'loading';
      state.error = null;
      state.creature = true
    })
    .addCase(copyPlan.fulfilled, (state, action)=> {  
      state.statusPlan = 'resolved'  
      state.creature = false
      const plansMap = new Map();
      state.plans.forEach(plan => {
        plansMap.set(`${plan.date}-${plan.owner}`, plan);
      });
      action.payload.forEach(updatedPlan => {
        plansMap.set(`${updatedPlan.date}-${updatedPlan.owner}`, updatedPlan);
      });
      
      // Преобразуем обратно в массив
      state.plans = Array.from(plansMap.values());
    })
    .addCase(copyPlan.rejected, (state, action)=> {
      state.statusPlan = 'rejected'  
      state.error = action.error.message;  
    })
    .addCase(generPlan.pending, (state, action)=> {  
      state.statusPlan = 'loading';
      state.error = null;
      state.creature = true
    })
    .addCase(generPlan.fulfilled, (state, action)=> {  
      state.statusPlan = 'resolved' 
      state.creature = false
      state.loadingRecipes = [];
      const plansMap = new Map();
      state.plans.forEach(plan => {
        plansMap.set(`${plan.date}-${plan.owner}`, plan);
      });
      action.payload.forEach(updatedPlan => {
        plansMap.set(`${updatedPlan.date}-${updatedPlan.owner}`, updatedPlan);
      });
      
      // Преобразуем обратно в массив
      state.plans = Array.from(plansMap.values());
    
    })
    .addCase(generPlan.rejected, (state, action)=> {
      state.statusPlan = 'rejected'  
      state.error = action.payload.message;  
      state.loadingRecipes = [];
    })
    .addCase(postPlanManual.pending, (state, action)=> {  
      state.statusPlan = 'loading';
      state.error = null;
      state.creature = true
    })
    .addCase(postPlanManual.fulfilled, (state, action)=> {  
      state.statusPlan = 'resolved' 
      console.log(action.payload)
      state.plans = action.payload.reduce((updatedPlans, newPlan) => {
        // Если план с таким _id уже есть — заменяем его, иначе добавляем
        const existingPlanIndex = updatedPlans.findIndex(plan => plan._id === newPlan._id);
        if (existingPlanIndex !== -1) {
          updatedPlans[existingPlanIndex] = newPlan; // Обновляем существующий
        } else {
          updatedPlans.push(newPlan); // Добавляем новый
        }
        return updatedPlans;
      }, [...state.plans]); // Начинаем с текущего состояния
    
      state.creature = false;
      /*const plansMap = new Map(state.plans.map(plan => [plan._id, plan]));
  
    // Обновляем или добавляем планы из action.payload
    action.payload.forEach(newPlan => {
      plansMap.set(newPlan._id, newPlan);
    });
  
    // Преобразуем обратно в массив
    state.plans = Array.from(plansMap.values());
    state.creature = false;*/
    })
    .addCase(postPlanManual.rejected, (state, action)=> {
      state.statusPlan = 'rejected'   
      state.error = action.payload.message;  
    })
    
    .addCase(deleteDishPlan.pending, (state, action)=> {  
      state.statusPlan = 'loading';
      state.error = null;
    })
    .addCase(deleteDishPlan.fulfilled, (state, action)=> {  
      state.statusPlan = 'resolved'
      state.plans = state.plans.map(plan => plan._id === action.payload._id ? action.payload : plan)
    })
    .addCase(deleteDishPlan.rejected, (state, action)=> {
      state.statusPlan = 'rejected'  
      state.error = action.error.message;  
    }) 
    .addCase(updatePlan.pending, (state, action)=> {  
      state.statusPlan = 'loading';
      state.error = null;
    })
    .addCase(updatePlan.fulfilled, (state, action)=> {  
      state.statusPlan = 'resolved'
      state.plans = state.plans.map(plan => plan._id === action.payload._id ? action.payload : plan)
      state.error = null;
    })
    .addCase(updatePlan.rejected, (state, action)=> { 
      state.statusPlan = 'rejected'  
      state.error = action.payload; 
    }) 
     .addCase(updatePlanFood.pending, (state, action)=> {  
      state.statusPlan = 'loading';
      state.error = null;
    })
    .addCase(updatePlanFood.fulfilled, (state, action)=> {  
      state.statusPlan = 'resolved'
      state.plans = state.plans.map(plan => plan._id === action.payload._id ? action.payload : plan)
      state.error = null;
    })
    .addCase(updatePlanFood.rejected, (state, action)=> { 
      state.statusPlan = 'rejected'  
      state.error = action.payload; 
    }) 
    .addCase(deletePlan.pending, (state, action)=> {  
      state.statusPlan = 'loading';
      state.error = null;
    })
    .addCase(deletePlan.fulfilled, (state, action)=> {  
      state.statusPlan = 'resolved'
      state.plans = state.plans.filter(plan => plan._id !== action.payload._id);
    })
    .addCase(deletePlan.rejected, (state, action)=> {
      state.statusPlan = 'rejected'  
      state.error = action.error.message;  
    }) 
  }
})
  export const { resetPaymentStatus} = reguestPaymentSlice.actions; 